import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';

export const SanityH3 = (props: React.PropsWithChildren<{}>) => {
  const { children } = props;
  return (
    <ouiDom.HeadingSection.DomH3
      lineFactor={1.1}
      color={ouiStyle.Constants.Colors.primary}
      paddingTop={['simple', undefined, undefined, 'simple', undefined, undefined]}
      paddingBottom={['simple', undefined, undefined, 'none', undefined, undefined]}
    >
      {children}
    </ouiDom.HeadingSection.DomH3>
  );
};
